const detectBrowserLanguage = require('detect-browser-language');
const { default: i18n } = require('../i18n');
const { DefaultLanguage, Languages } = require('../i18n/languages');

const getDetectedLanguage = () => {
  const detectedLang = detectBrowserLanguage();
  if (!detectedLang) {
    return DefaultLanguage;
  }
  const val = detectedLang.split('-')[0];
  if (Languages[val]) {
    return val;
  }

  return DefaultLanguage;
};

export const getLanguage = (location) => {
  const search = new URLSearchParams(location.search || '');

  let lang = search.get('lang');
  if (!lang || !Languages[lang]) {
    lang = getDetectedLanguage();
  }

  i18n.changeLanguage(lang);
  return lang;
};
